export default {
  user: null,
  watchList: [],
  preferences: null,
  licenseList: null,
  watchListOnly: false,
  selectedUniverses: null,
}
